import { render } from "./ImportView.vue?vue&type=template&id=39a1c270"
import script from "./ImportView.vue?vue&type=script&lang=js"
export * from "./ImportView.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__